// import React from "react";
// import logo from '../Assets/homeimg.gif'
// const RazorpayPayment = ({amount,name,address}) => {
//   console.log(amount,name,address,'loerhwrtge')
//   const loadRazorpay = (src) => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = src;
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handlePayment = async () => {
//     const res = await loadRazorpay("https://checkout.razorpay.com/v1/checkout.js");

//     if (!res) {
//       alert("Razorpay SDK failed to load. Check your internet.");
//       return;
//     }

//     const options = {
//       key: "rzp_test_RROfiSxPJK4gY1", // ✅ Replace with your Key ID
//       amount: amount, // Amount in paise (example ₹500)
//       currency: "INR",
//       name: "Oye Pai",
//       description: "Test Transaction",
//       image: logo,
//       handler: function (response) {
//         alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
//       },
//       prefill: {
//         name: "Karthik",
//         email: "karthik@example.com",
//         contact: "7397109901",
//       },
//       theme: {
//         color: "#3399cc",
//       },
//     };

//     const paymentObject = new window.Razorpay(options);
//     paymentObject.open();
//   };

//   return (
//     <div style={{ textAlign: "center", marginTop: "50px" }}>
//       <h2>Razorpay Integration</h2>
//       <button
//         onClick={handlePayment}
//         style={{
//           padding: "12px 24px",
//           backgroundColor: "#3399cc",
//           color: "#fff",
//           border: "none",
//           borderRadius: "5px",
//           cursor: "pointer",
//         }}
//       >
//         Pay ₹{amount}
//       </button>
//     </div>
//   );
// };

// export default RazorpayPayment;


import React, { useCallback } from "react";
import logo from "../Assets/homeimg.gif";

const RazorpayPayment = ({
  amount,          // total in rupees (₹)
  name,
  address,
  phone,
  cart,
  onSuccess,       // called when payment succeeds → switch to success step
  onCancel,        // called when user clicks Cancel → go back to address step
}) => {
  // --------------------------------------------------------------
  // Load Razorpay SDK only once
  // --------------------------------------------------------------
  const loadRazorpay = useCallback(() => {
    return new Promise((resolve) => {
      const existing = document.getElementById("razorpay-script");
      if (existing) return resolve(true);

      const script = document.createElement("script");
      script.id = "razorpay-script";
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  }, []);

  // --------------------------------------------------------------
  // Payment handler
  // --------------------------------------------------------------
  const initiatePayment = async () => {
    const res = await loadRazorpay();
    if (!res) {
      alert("Razorpay SDK failed to load. Check your internet connection.");
      return;
    }

    const options = {
      key: "rzp_test_RROfiSxPJK4gY1", // <-- replace with your live key in prod
      amount: amount * 100, // Razorpay expects **paise**
      currency: "INR",
      name: "Oye Pai",
      description: "Food order payment",
      image: logo,
      handler: (response) => {
        // Payment succeeded
        onSuccess?.(response.razorpay_payment_id);
      },
      prefill: {
        name,
        contact: phone,
        // Razorpay does not pre-fill address, but you can add custom notes
      },
      notes: {
        address,
      },
      theme: { color: "#f97316" }, // orange to match your gradient
    };

    const razorpay = new window.Razorpay(options);
    razorpay.on("payment.failed", (response) => {
      alert(`Payment failed: ${response.error.description}`);
    });

    razorpay.open();
  };

  // --------------------------------------------------------------
  // UI
  // --------------------------------------------------------------
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-800">Secure Payment</h2>
        <button
          onClick={onCancel}
          className="text-gray-400 hover:text-gray-600 transition"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Order summary (same style as address step) */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h3 className="font-medium text-gray-800 mb-2">Order Summary</h3>
        {cart.map((item) => (
          <div
            key={item.id}
            className="flex justify-between text-sm text-gray-600 mb-1"
          >
            <span>
              {item.name} × {item.quantity}
            </span>
            <span>₹{item.price * item.quantity}</span>
          </div>
        ))}
        <div className="border-t pt-2 mt-2">
          <div className="flex justify-between font-bold text-gray-800">
            <span>Total</span>
            <span>₹{amount}</span>
          </div>
        </div>
      </div>

      {/* Customer info (read-only) */}
      <div className="space-y-2 text-sm text-gray-600">
        <p>
          <strong>Name:</strong> {name}
        </p>
        <p>
          <strong>Phone:</strong> {phone}
        </p>
        <p>
          <strong>Delivery:</strong> {address}
        </p>
      </div>

      {/* Pay button */}
      <button
        onClick={initiatePayment}
        className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-lg font-medium
                   hover:shadow-xl transition-all duration-300 transform hover:scale-105"
      >
        Pay ₹{amount}
      </button>

      {/* Cancel button */}
      <button
        onClick={onCancel}
        className="w-full border border-gray-300 text-gray-700 py-2 rounded-lg font-medium
                   hover:bg-gray-50 transition"
      >
        Cancel
      </button>
    </div>
  );
};

export default RazorpayPayment;
